"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$uiPlaceholder = exports.$uiConnector = exports.$uiDivider = exports.$uiRange = exports.$uiS3Uploader = exports.$uiVisual = exports.$uiFocus = exports.$uiShowOnHover = exports.$uiIconSvg = exports.$uiIconStack = exports.$uiLoader = exports.$uiAlert = exports.$uiBadge = exports.$uiInfo = exports.$uiMenuFolder = exports.$uiMenuDropdown = exports.$uiPanel = exports.$uiOverlay = exports.$uiBottomToolbar = exports.$uiView = exports.$uiModal = exports.$uiCard = exports.$uiFormRow = exports.$uiForm = exports.$uiTable = exports.$uiInputGroupLegacy = exports.$uiInputGroup = exports.$uiAutosizeInput = exports.$uiSelect = exports.$uiInputText = exports.$uiCalendar = exports.$uiCollapser = exports.$uiStatusFilter = exports.$uiButtonSwitch = exports.$uiButton = exports.$uiCheckboxLegacy = exports.$uiCheckbox = exports.$uiA = void 0;
// Do not edit directly
// Generated on Wed, 31 Jan 2024 01:00:34 GMT
var $uiA = 'env-a-'; // ACSS

exports.$uiA = $uiA;
var $uiCheckbox = 'env-checkbox'; // Control

exports.$uiCheckbox = $uiCheckbox;
var $uiCheckboxLegacy = 'env-checkbox-legacy'; // Control

exports.$uiCheckboxLegacy = $uiCheckboxLegacy;
var $uiButton = 'env-button'; // Control

exports.$uiButton = $uiButton;
var $uiButtonSwitch = 'env-button-switch'; // Control

exports.$uiButtonSwitch = $uiButtonSwitch;
var $uiStatusFilter = 'env-status-filter'; // Control

exports.$uiStatusFilter = $uiStatusFilter;
var $uiCollapser = 'env-collapser'; // Control

exports.$uiCollapser = $uiCollapser;
var $uiCalendar = 'env-calendar'; // Control

exports.$uiCalendar = $uiCalendar;
var $uiInputText = 'env-input-text'; // Input

exports.$uiInputText = $uiInputText;
var $uiSelect = 'env-select'; // Input

exports.$uiSelect = $uiSelect;
var $uiAutosizeInput = 'env-autosize-input'; // Input

exports.$uiAutosizeInput = $uiAutosizeInput;
var $uiInputGroup = 'env-input-group'; // Input

exports.$uiInputGroup = $uiInputGroup;
var $uiInputGroupLegacy = 'env-input-group-legacy'; // Input

exports.$uiInputGroupLegacy = $uiInputGroupLegacy;
var $uiTable = 'env-table'; // Table

exports.$uiTable = $uiTable;
var $uiForm = 'env-form'; // Form

exports.$uiForm = $uiForm;
var $uiFormRow = 'env-form-row'; // Form

exports.$uiFormRow = $uiFormRow;
var $uiCard = 'env-card'; // Container

exports.$uiCard = $uiCard;
var $uiModal = 'env-modal'; // Container

exports.$uiModal = $uiModal;
var $uiView = 'env-view'; // Container

exports.$uiView = $uiView;
var $uiBottomToolbar = 'env-bottom-toolbar'; // Container

exports.$uiBottomToolbar = $uiBottomToolbar;
var $uiOverlay = 'env-overlay'; // Container

exports.$uiOverlay = $uiOverlay;
var $uiPanel = 'env-panel'; // Container

exports.$uiPanel = $uiPanel;
var $uiMenuDropdown = 'env-menu-dropdown'; // Menu

exports.$uiMenuDropdown = $uiMenuDropdown;
var $uiMenuFolder = 'env-menu-folder'; // Menu

exports.$uiMenuFolder = $uiMenuFolder;
var $uiInfo = 'env-info'; // Info

exports.$uiInfo = $uiInfo;
var $uiBadge = 'env-badge'; // Info

exports.$uiBadge = $uiBadge;
var $uiAlert = 'env-alert'; // Info

exports.$uiAlert = $uiAlert;
var $uiLoader = 'env-loader'; // Info

exports.$uiLoader = $uiLoader;
var $uiIconStack = 'env-icon-stack'; // Icon

exports.$uiIconStack = $uiIconStack;
var $uiIconSvg = 'env-icon-svg'; // Icon

exports.$uiIconSvg = $uiIconSvg;
var $uiShowOnHover = 'env-show-on-hover'; // Abstract

exports.$uiShowOnHover = $uiShowOnHover;
var $uiFocus = 'env-focus'; // Abstract

exports.$uiFocus = $uiFocus;
var $uiVisual = 'env-visual'; // Specific

exports.$uiVisual = $uiVisual;
var $uiS3Uploader = 'env-s3-uploader'; // Third party

exports.$uiS3Uploader = $uiS3Uploader;
var $uiRange = 'env-range'; // Input

exports.$uiRange = $uiRange;
var $uiDivider = 'env-divider'; // Info

exports.$uiDivider = $uiDivider;
var $uiConnector = 'env-connector'; // Abstract

exports.$uiConnector = $uiConnector;
var $uiPlaceholder = 'env-placeholder'; // Abstract
//
// JS block names

exports.$uiPlaceholder = $uiPlaceholder;